import { useRouterState } from "@tanstack/react-router";

const STATIC_MIRRORS = new Set([
  "/", "/about", "/solutions", "/industries", "/projects",
  "/ask-arif", "/insights", "/learning-center", "/media", "/partners", "/contact",
]);

function mirrorPathFor(pathname: string): string | null {
  const p = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  if (STATIC_MIRRORS.has(p)) return p === "/" ? "/index.md" : `${p}.md`;
  if (/^\/solutions\/[^/]+$/.test(p)) return `${p}.md`;
  if (/^\/industries\/[^/]+$/.test(p)) return `${p}.md`;
  if (/^\/ask-arif\/[^/]+$/.test(p) && !p.startsWith("/ask-arif/category/")) return `${p}.md`;
  return null;
}

/**
 * Visible in-page discovery link to the Markdown mirror of the current page.
 * Renders nothing on routes without a mirror.
 */
export function MarkdownMirrorLink({ className }: { className?: string }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const mirror = mirrorPathFor(pathname);
  if (!mirror) return null;
  return (
    <a
      href={mirror}
      rel="alternate"
      type="text/markdown"
      className={className ?? "text-ink-soft hover:text-primary transition-colors"}
      title="Plain-text Markdown mirror of this page (for LLMs and AI search)"
    >
      View as Markdown
    </a>
  );
}
